import { utils } from '@febos-io/common';

import * as types from './types';
import { actions } from './reducer';
import {CLEAR_USER_SESSION} from './types';

export const setLoading = (loading) => (
  utils.createActionCreator(
    types.SET_LOADING,
    loading,
    actions
  )
);

export const setUserSession = (userSession) => (
  utils.createActionCreator(
    types.SET_USER_SESSION,
    userSession,
    actions
  )
);

export const removeUser = () => (
  utils.createActionCreator(
    types.REMOVE_USER,
    undefined,
    actions
  )
);

export const clearUserSession = () => (
  utils.createActionCreator(
    types.CLEAR_USER_SESSION,
    undefined,
    actions
  )
);

export const handleSignIn = (
  user,
  isFederated,
  {
    navigate,
    singlePathname,
    isExternalAuth,
    multiplePathname,
  }
) => (
  utils.createActionCreator(
    types.HANDLE_SIGN_IN,
    {
      user,
      isFederated,
      config: {
        navigate,
        singlePathname,
        isExternalAuth,
        multiplePathname,
      },
    },
    actions
  )
);

export const handleSignInError = (event) => (
  utils.createActionCreator(
    types.HANDLE_SIGN_IN_ERROR,
    {
      event,
    },
    actions
  )
);

export const setUserCompany = (payload) => (
  utils.createActionCreator(
    types.SET_USER_COMPANY,
    payload,
    actions
  )
);

export const setUserMetadata = (companies) => (
  utils.createActionCreator(
    types.SET_USER_METADATA,
    { companies, },
    actions
  )
);

export const setUserInfo = (info) => (
  utils.createActionCreator(
    types.SET_USER,
    info,
    actions
  )
);

export const setUserClinic = (clinic) => (
  utils.createActionCreator(
    types.SET_USER_CLINIC,
    clinic,
    actions
  )
);
